import { render, staticRenderFns } from "./certificate-detail.vue?vue&type=template&id=6e9856d2&scoped=true&"
import script from "./certificate-detail.vue?vue&type=script&lang=js&"
export * from "./certificate-detail.vue?vue&type=script&lang=js&"
import style0 from "./certificate-detail.vue?vue&type=style&index=0&id=6e9856d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9856d2",
  null
  
)

export default component.exports